import { render, staticRenderFns } from "./ChangeStyle.vue?vue&type=template&id=2d955735&scoped=true&"
import script from "./ChangeStyle.vue?vue&type=script&lang=ts&"
export * from "./ChangeStyle.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d955735",
  null
  
)

export default component.exports